import {isBoolTrue} from "./fusion-ui/utils/ReactUtils";

const env = process.env;

// export const AppDateFormat = "ddd, DD-MMM-YYYY, hh:mm A";
// export const TextEditorApiKey = 'w7m8twcv5meah2tx0phtg9j05rxyqxkunj8ndurx8phi79ro';//Generated using: knp-email, 17May2024
// export const DebugOn = true;
// export const IsProd = false;
// export const SESSION_RECHECK_INTERVAL_SECONDS = 10000;//10s
// export const BaseReqUrl = IsProd ? "https://vokbeta.kolsandpeers.com/vokapi" : "http://localhost:8050";

export const IsProd = isBoolTrue(env.REACT_APP__IS_PROD);
export const DebugOn = isBoolTrue(env.REACT_APP__DEBUG_ON);
export const UnderMaintenance = isBoolTrue(env.REACT_APP__UNDER_MAINTENANCE);
export const AppDateFormat = env.REACT_APP__DATE_FORMAT;
export const TextEditorApiKey = env.REACT_APP__TEXT_EDITOR_API_KEY;
export const SESSION_RECHECK_INTERVAL_SECONDS = parseInt(env.REACT_APP__SESSION_RECHECK_INTERVAL_SECONDS);
export const EVENT_INPUT_MAX_LEN = parseInt(env.REACT_APP__EVENT_INPUT_MAX_LEN);
export const INPUT_FILE_MAX_SIZE = env.REACT_APP__INPUT_FILE_MAX_SIZE;
export const BaseReqUrl = IsProd ? env.REACT_APP__BASE_REQ_URL_PROD : env.REACT_APP__BASE_REQ_URL_LOCAL;
// export const UnderMaintenanceMsg = `This functionality is not accessible at the moment due to ongoing tests.`;
// export const UnderMaintenanceMsg = `This functionality is currently unavailable as it is undergoing testing.`;
export const UnderMaintenanceMsg = `For quality assurance & testing purposes, this functionality is temporarily unavailable.`;
// export const UnderMaintenanceMsg = `Access to this operation has been temporarily restricted while we conduct essential testing.`;
// printLog('CommonConfig: BaseReqUrl:', BaseReqUrl);

console.log('IsProd:', IsProd, 'DebugOn:', DebugOn, 'UnderMaintenance:', UnderMaintenance, 'AppDateFormat:', AppDateFormat, 'TextEditorApiKey:', TextEditorApiKey, 'SESSION_RECHECK_INTERVAL_SECONDS:', SESSION_RECHECK_INTERVAL_SECONDS, 'BaseReqUrl:', BaseReqUrl);

export const ThemeNames = {
    //These values should correspond to the css-file names in "./assets/css/", bcuz that's how they're imported in "App.js" "importThemeCssFile()" function.
    ORCHID: env.REACT_APP__THEME_NAME__ORCHID || 'Orchid',
    ROYAL_BLUE: env.REACT_APP__THEME_NAME__ROYAL_BLUE || 'RoyalBlue',
};

// console.log(
//     "Env-values:\nIS_PROD:", isBoolTrue(env.REACT_APP__IS_PROD),
//     "\nDEBUG_ON:", isBoolTrue(env.REACT_APP__DEBUG_ON),
//     "\nSESSION_RECHECK_INTERVAL_SECONDS:", parseInt(env.REACT_APP__SESSION_RECHECK_INTERVAL_SECONDS),
//     "\nBASE_REQ_URL_LOCAL:", env.REACT_APP__BASE_REQ_URL_LOCAL,
//     "\nBASE_REQ_URL_PROD:", env.REACT_APP__BASE_REQ_URL_PROD,
//     "\nDATE_FORMAT:", env.REACT_APP__DATE_FORMAT,
//     "\nTEXT_EDITOR_API_KEY:", env.REACT_APP__TEXT_EDITOR_API_KEY,
//     "\nTHEME_NAME__ORCHID:", env.REACT_APP__THEME_NAME__ORCHID,
//     "\nTHEME_NAME__ROYAL_BLUE:", env.REACT_APP__THEME_NAME__ROYAL_BLUE,
//     "\nAPP_NAME:", env.REACT_APP__APP_NAME,
//     "\nINPUT_FILE_MAX_SIZE:", env.REACT_APP__INPUT_FILE_MAX_SIZE,
//     "\nEVENT_INPUT_MAX_LEN:", parseInt(env.REACT_APP__EVENT_INPUT_MAX_LEN),
//     "\nADMIN_APP_NAME:", env.REACT_APP__ADMIN_APP_NAME,
// );
